const request = require('request-promise');
const logger = require('./logger').debugLogger;
const requestDebug = require('request-debug');

const logRequest = (type, requestData) => {
  logger.info('Microsoft SDK did a %s', type);
  logger.info('details: %j', requestData);
};

requestDebug(request, logRequest);

module.exports = request;
